import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../Styles/Blog.css";
import contactImg from '../newimgs/contreal.png'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCalendarDay,
  faCalendar,
  faMessage,
} from "@fortawesome/free-solid-svg-icons";
import "../assets/css/custom-animation.css";
import "../assets/css/animate.min.css";
import { animateScroll as scroll } from "react-scroll";
import axios from "axios";
import moment from "moment/moment";
import BlogForm from "./BlogForm";

const Blog2 = () => {
  const toggleContact = () => {
    scroll.scrollToTop(0, 0);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [posts, setPosts] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("https://mars.zithas.com/api/blog")
      .then((res) => {
        setPosts(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

 
  

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };


  

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
    //       const response = await axios.post("https://mars.zithas.com/api/contact",formData,
    //    {
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //     },
    //   }
    // );
      alert("Form submitted successfully!");
      console.log(formData)
      // console.log("Response:", response.data);

      // Reset form
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("There was an error submitting the form. Please try again later.");
    }
  };

  return (
<div>
<div>
<section className="bd-blog-area pt-40 pb-80 blogOne blogOneMin">
  <div className="container">
    {/* Responsive Flexbox Layout */}
    <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-5">
      
      {/* Left Side - Image */}
      <div style={{ flex: "1 1 400px", maxWidth: "600px" }}>
        <div className="bd-section-title-wrapper mb-30 d-flex justify-content-center align-items-center">
          <img
            src={contactImg}
            alt="Contact Us"
            style={{
              width: "100%",
              height: "auto",
              objectFit: "cover",
            }}
          />
        </div>
      </div>

      {/* Right Side - Form (Your Original Code) */}
      <div style={{ flex: "1 1 400px", maxWidth: "600px" }}>
        <div className="bd-section-title-wrapper mb-50">
          <form onSubmit={handleSubmit}>
            <div className="row contact-reponsive">
              <div className="col-md-6">
                <div className="bd-contact-field mb-30">
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="First Name"
                    className="contact-form form-reponsive"
                    style={{ border: "1px solid black" }}
                    required
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="bd-contact-field mb-30">
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    className="form-reponsive"
                    placeholder="Last Name"
                    style={{ border: "1px solid black" }}
                    required
                  />
                </div>
              </div>

              <div className="col-6 email-form-responsive">
                <div className="bd-contact-field mb-30">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-reponsive"
                    placeholder="Email"
                    style={{ border: "1px solid black" }}
                    required
                  />
                </div>
              </div>

              <div className="col-6 email-form-responsive">
                <div className="bd-contact-field mb-30">
                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="form-reponsive"
                    placeholder="Phone no"
                    style={{ border: "1px solid black" }}
                    required
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="bd-contact-field mb-30">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Share your Message"
                    style={{
                      height: "220px",
                      width: "100%",
                      border: "1px solid black",
                    }}
                    required
                  ></textarea>
                </div>
              </div>

              <div className="col-12">
                <div className="bd-contact-field">
                  <button type="submit" className="theme-btn">
                    Submit Enquiry
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
</section>

</div>


</div>
  );
};

export default Blog2;
